



























































import {TokenPriced} from '@/model/resource/TokenPriced'
import {InputTokenPricedSchema} from '@/schema/resource/TokenPriced/InputTokenPricedSchema'
import {Component, Prop, Vue} from 'vue-property-decorator'
import {InputText} from '@simpli/vue-input'
import SelectMultipleDapps from '@/components/SelectMultipleDapps.vue'
import {DappCollection} from '@/model/collection/DappCollection'
import {Contract} from '@/model/resource/Contract'
import {$} from '@/facade'

@Component({
  components: {
    SelectMultipleDapps,
    InputText,
  },
})
export default class TokenPricedModal extends Vue {
  @Prop({type: TokenPriced, required: true}) token!: TokenPriced

  collectionDapp = new DappCollection().noPagination()

  showModal: boolean = false
  schema = new InputTokenPricedSchema()
  open = false

  originalCreatorAddress: string | null = null
  originalDappId: number | null = null
  origitalTempCreatorDapp: string | null = null

  get tempCreatorDapp() {
    return this.token.contract?.tempCreatorDapp ?? ''
  }

  set tempCreatorDapp(value: string) {
    if (this.token.contract) {
      this.token.contract.tempCreatorDapp = value
    } else {
      this.token.contract = new Contract()
      this.token.contract.tempCreatorDapp = value
    }
  }

  get creatorAddress() {
    return this.token.contract?.creatorAddress ?? ''
  }

  set creatorAddress(value: string) {
    if (this.token.contract) {
      this.token.contract.creatorAddress = value
    } else {
      this.token.contract = new Contract()
      this.token.contract.creatorAddress = value
    }
  }

  get dappTitle() {
    return this.token.dapp?.title ?? ''
  }

  async persistTokenPriced() {
    await $.await.run('softQuery', async () => {
      const originalAddress = this.originalCreatorAddress
      const originalDappId = this.originalDappId
      const originalTempCreatorDapp = this.origitalTempCreatorDapp

      const currentAddress = this.creatorAddress || null
      const currentDappId = this.token.dapp?.idDappPk ?? null
      const currentTempCreatorDapp =
        this.token.contract?.tempCreatorDapp ?? null

      const addressChanged = originalAddress !== currentAddress
      const dappChanged = originalDappId !== currentDappId
      const tempCreatorDappChanged =
        originalTempCreatorDapp !== currentTempCreatorDapp

      if (addressChanged || dappChanged || tempCreatorDappChanged) {
        if (!this.token.contract) return

        this.token.contract.creatorAddress = currentAddress
        this.token.contract.dapp = this.token.dapp
        this.token.contract.tempCreatorDapp = currentTempCreatorDapp

        if (this.token.contract.idContractPk) {
          await this.token.contract.persistContract()
        }
      }

      await this.token.persistTokenPriced()

      $.toast.success('system.success.persist')

      this.showModal = false

      this.$emit('persisted')
    })
  }

  private toggleModal(): void {
    this.origitalTempCreatorDapp = this.token.contract?.tempCreatorDapp ?? null
    this.originalCreatorAddress = this.token.contract?.creatorAddress ?? null
    this.originalDappId = this.token.contract?.dapp?.idDappPk ?? null
    this.showModal = !this.showModal
  }
}
